import type { ListingRef } from '../lib/types';
import { ConfirmListingModal } from './ConfirmListingModal';

export type ExcludeListingModalProps = {
  /** Shows the dialog while set. */
  listing: Pick<ListingRef, 'title' | 'sku'> | null;
  onClose: () => void;
  onConfirm: () => void;
  isProcessing?: boolean;
};

/** Asks before a listing is kept unmapped on purpose. */
export function ExcludeListingModal({
  listing,
  onClose,
  onConfirm,
  isProcessing,
}: ExcludeListingModalProps) {
  return (
    <ConfirmListingModal
      isOpen={!!listing}
      title="Exclude listing"
      confirmLabel="Exclude"
      onClose={onClose}
      onConfirm={onConfirm}
      isProcessing={isProcessing}
    >
      Keep <b>{listing?.title ?? listing?.sku}</b> unmapped on purpose? Orders
      and stock pulls will not match it to a catalog item. You can map it later.
    </ConfirmListingModal>
  );
}
